module.exports = __webpack_public_path__ + "static/media/Portrait-10034.8779bb25.jpg";